/***
 *
 *   AUTH LAYOUT
 *   Layout for the signup/signin pages
 *
 **********/

import loginSchool from "@/images/ghs_login.png";
import Style from "./auth.tailwind";

export function AuthLayout(props) {
  return (
    <main className={Style.auth}>
      {<props.children {...props.data} />}
      <img src={loginSchool} alt="GHS Login" className="hidden lg:block h-screen w-1/2" />
    </main>
  );
}
